import { CognitoUser } from "./types";
import { AttributeType } from "@aws-sdk/client-cognito-identity-provider/dist-types/models/models_0";
import { UserProfile } from "../auth/types";

export const getFirstName = (userProfile?: UserProfile): string => {
  return userProfile?.firstName ?? "";
};

export const getLastName = (userProfile?: UserProfile): string => {
  return userProfile?.lastName ?? "";
};

export const getFullName = (userProfile?: UserProfile): string => {
  const first = getFirstName(userProfile);
  const last = getLastName(userProfile);
  const hasSpace = first && last;
  return `${first}${hasSpace ? " " : ""}${last}`;
};

const attributeMap: { [key: string]: keyof CognitoUser } = {
  "custom:user_id": "ssoId",
  given_name: "firstName",
  family_name: "lastName",
  email: "email",
  email_verified: "emailConfirmed",
};

export const mapToCognitoUser = (attributes?: AttributeType[]): CognitoUser => {
  let cognitoUser: CognitoUser = {
    ssoId: "",
    firstName: "",
    lastName: "",
    email: "",
    emailConfirmed: false,
  };

  attributes?.forEach((attr) => {
    if (attr.Name) {
      const prop = attributeMap[attr.Name];

      if (prop) {
        if (prop === "emailConfirmed") {
          cognitoUser[prop] = attr.Value === "true";
        } else {
          // @ts-ignore
          cognitoUser[prop] = attr.Value;
        }
      }
    }
  });

  return cognitoUser;
};
